import React from 'react';
import b_ from 'b_';

import {createUrl} from 'client/common/utils/history';
import {Link} from 'client/common/components/lego';
import {sendGoal} from 'client/common/utils/metrika';
import {PollLandingGoal} from 'client/common/types';

import I18N from 'assets/i18n/poll-landing';

import './footer.css';

const i18n = I18N.footer;
const b = b_.with('footer');

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <div className={b()}>
            <div className={b('disclaimer')}>{i18n.disclaimer}</div>
            <ul className={b('links')}>
                <li className={b('link-item')}>
                    <a
                        href={createUrl({link: i18n.aboutUrl})}
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {i18n.aboutText}
                    </a>
                </li>
                <li className={b('link-item')}>
                    <a
                        href={createUrl({link: i18n.ofertaUrl})}
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {i18n.ofertaText}
                    </a>
                </li>
                <li
                    className={b('link-item')}
                    onClick={() => sendGoal(PollLandingGoal.ActionFooterLinkClick)}
                >
                    {'© '}
                    <Link
                        href={createUrl({link: i18n.copyrightUrl})}
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        {i18n.copyrightText}
                    </Link>
                    {` ${year.toString()}`}
                </li>
            </ul>
        </div>
    );
};

export default Footer;
